// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__JT3sE","title":"ClientInsurance_title__2m9op","itemText":"ClientInsurance_itemText__CUHIj"};